var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterPrivacyPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.421 6.89474C11.0488 6.89474 12.3684 5.57516 12.3684 3.94737C12.3684 2.31958 11.0488 1 9.421 1C7.79321 1 6.47363 2.31958 6.47363 3.94737C6.47363 5.57516 7.79321 6.89474 9.421 6.89474Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.5789C1 12.8583 4.39322 9.8421 8.57895 9.8421",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7692 10.2308C15.7692 10.6722 15.7692 12.0769 15.7692 12.0769H12.0769C12.0769 12.0769 12.0769 11.2504 12.0769 10.2308C12.0769 9.21118 12.9035 8.38461 13.9231 8.38461C14.9426 8.38461 15.7692 9.21118 15.7692 10.2308Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8462 12.0769H17V16.6923H10.8462V12.0769Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterPrivacyPrivate);
export default __webpack_public_path__ + "static/media/filter-privacy-private.a5ff993884b9a7cadf263b14c90d4178.svg";
export { ForwardRef as ReactComponent };